const userDetails = {
  infoCard: {
    countApps: 'Количество программ',
    payments: 'Платежи',
    spendings: 'Расходы',
    email: 'Электронная почта',
    id: 'ID',
    currentPlan: 'Текущий план',
    balance: 'Баланс',
    status: 'Статус',
    active: 'Активный',
    registrationDate: 'Дата регистрации',
    lastLogin: 'Последний вход',
    country: 'Страна',
    refEmail: 'Реферер',
    reflinkId: 'Код рефлинки',
    externalParams: 'Внешние параметры',
  },
  editCard: {
    editDetail: 'Редактировать данные пользователя',
    activateUser: 'Активировать пользователя',
    resendEmail: 'Отправить электронное письмо повторно',
    removeUser: 'Удалить пользователя',
    email: 'Электронная почта',
    phone: 'Телефон',
    role: 'Роль',
    priceplan: 'Ценовой план',
    manager: 'Менеджер',
    refId: 'RefLink',
    isUserEuPayee: 'Пользователь является получателем платежа из ЕС',
    save: 'Сохранить',
    userActivated: 'Пользователь успешно активирован',
    userDeleted: 'Пользователи успешно удалены',
    userChanged: 'Изменения к пользователям успешно применены.',
  },
  paymentsTable: {
    userPayments: 'Платежи',
    showing: 'показано',
    paymentsOf: 'платежи из',
    noUserPaymentsFound: 'Платежи пользователя не найдены',
  },
  transactionTable: {
    userTransactions: 'Трансакции',
    showing: 'показано',
    transactionsOf: 'транзакции из',
    noUserTransactionsFound: 'Трансакция пользователя не найдена',
  },
  referralTable: {
    userReferrals: 'Рефералы пользователей',
    showing: 'показывается',
    referralsOf: 'рефералы',
    noUserReferralsFound: 'Рефералы пользователей не найдены',
    addNew: 'Добавить реферал',
    addNewSuccess: 'Реферал успешно добавлен',
  },
  changeBalanceCard: {
    changeBalance: 'Изменить баланс пользователя',
    amount: 'Сумма',
    account: 'Счет',
    type: 'Тип',
    reason: 'Причина',
    id: 'Уникальный идентификатор платежа',
    paymentId: 'Идентификатор платежа',
    generate: 'Сгенерировать',
    description: 'Описание',
    balanceChanged: 'Баланс успешно изменен',
  },
  reflinksModal: {
    reflinksList: 'История реферальных ссылок',
    name: 'Имя',
    code: 'Код',
    created: 'Создано',
  },
  externalModal: {
    externalParams: 'Внешние параметры',
    value: 'Значение',
  },
  tableDropdown: {
    exportUserPayments: 'Экспорт'
  },
  messagesTable: {
    userMessages: 'Сообщение',
    showing: 'Показ',
    recordes: 'записи',
    noUserMessagesFound: 'Сообщений пользователя не найдено',
  },
};

export default userDetails;
